import { render, staticRenderFns } from "./ClassroomDetailTabSubmissions.vue?vue&type=template&id=87cde7bc&scoped=true"
import script from "./ClassroomDetailTabSubmissions.vue?vue&type=script&lang=js"
export * from "./ClassroomDetailTabSubmissions.vue?vue&type=script&lang=js"
import style0 from "./ClassroomDetailTabSubmissions.vue?vue&type=style&index=0&id=87cde7bc&prod&lang=stylus&scoped=true"
import style1 from "./ClassroomDetailTabSubmissions.vue?vue&type=style&index=1&id=87cde7bc&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87cde7bc",
  null
  
)

export default component.exports